import Vue from "vue";
import Vuex from "vuex";
import router from "./router";

import auth from "./store/auth";
import passwordRecovery from "./store/passwordRecovery";
import usernameRecovery from "./store/usernameRecovery";
import workspace from "./store/workspace";
import newPassword from "./store/newPassword";
import loading from "./store/loading";
import error from "./store/error";
import success from "./store/success";
import profile from "./store/profile";
import VuexPersistence from "vuex-persist";
import operators from "./store/operators";
import notifications from "./store/notifications";
import newsTutorial from "./store/newsTutorial";
import appointments from "./store/appointments";
import faq from "./store/faq";
import contact from "./store/contact";
import bookings from "./store/bookings";
import appointment from "./store/appointment";
import hfManagement from "./store/hfManagement";
import members from "./store/members";
import memberAppointments from "./store/memberAppointments";
import bills from "./store/bills";
import billAppointments from "./store/billAppointments";
import doctors from "./store/doctors";
import machinery from "./store/machinery";
import hfServices from "./store/hfServices";
import confirm from "./store/confirm";
import billDocuments from "./store/billDocuments";
import session from "./store/session";
import billInvoiceInfo from "./store/billInvoiceInfo";
import billsPayments from "./store/billsPayments";

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== "production";

const storeModules = {
  auth,
  passwordRecovery,
  usernameRecovery,
  newPassword,
  workspace,
  profile,
  loading,
  error,
  success,
  operators,
  notifications,
  newsTutorial,
  appointments,
  faq,
  contact,
  members,
  memberAppointments,
  bills,
  billsPayments,
  billAppointments,
  appointment,
  hfManagement,
  doctors,
  machinery,
  hfServices,
  confirm,
  bookings,
  billDocuments,
  session,
  billInvoiceInfo
};

/**
 * VuexPersistence storage using sessionStorage
 * and all application modules
 */
const vuexSecure = new VuexPersistence({
  storage: window.sessionStorage,
  modules: Object.keys(storeModules).filter(el => el != "billDocuments") // exclude billDocuments module used during upload
});

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async logout({ dispatch }) {
    await dispatch("clearAll", { whiteList: [] }, { root: true });
    router.push({ name: "login" });
  },
  clearAll({ commit }, { whiteList }) {
    whiteList = whiteList || [];

    // SECOND PRIORITY STORES
    // !NOTE: THE ORDER HAS AN IMPACT (i.e store 'auth' should be the last one)
    let storeSecondPriority = [
      "hfManagement",
      "session",
      "auth",
      "loading"
    ].filter(s => !whiteList.includes(s));

    for (const s in storeModules) {
      if (storeSecondPriority.includes(s) || whiteList.includes(s)) continue;

      if (storeModules[s].mutations.RESET != null) {
        commit(`${s}/RESET`);
      }
    }

    // CLEAR STORES WITH LOWER PRIORITY
    storeSecondPriority.forEach(s => {
      commit(`${s}/RESET`);
    });

    window.sessionStorage.clear();
    window.sessionStorage.clear();
  }
};

const store = new Vuex.Store({
  modules: storeModules,
  strict: debug,
  state,
  getters,
  mutations,
  actions,
  plugins: [vuexSecure.plugin]
});
export default store;
